import { inject, Injectable } from '@angular/core';
import { CookieConsentService } from '@sb-shared/services/cookie-consent.service';
import { ScriptLoaderService } from '@sb-shared/services/script-loader.service';
import { filter, take } from 'rxjs/operators';

const CLARITY_TAG_URL = 'https://www.clarity.ms/tag/mufxo6jefz';

@Injectable({
  providedIn: 'root'
})
export class ClarityService {
  private loaded = false;

  private readonly cookieConsent = inject(CookieConsentService);
  private readonly scriptLoader = inject(ScriptLoaderService);

  /** Loads Clarity once Analytics consent is given (SB-17045), now or later in the session. */
  load(): void {
    if (this.loaded) {
      return;
    }

    this.loaded = true;

    if (!window.EveryBuddy.EnableClarity || ClarityService.isAppleWebKitMobile()) {
      console.log('Clarity disabled');
      return;
    }

    this.cookieConsent.analyticsConsent$.pipe(filter(Boolean), take(1)).subscribe(() => {
      // Queue stub from Microsoft's snippet, so calls made before the tag loads are kept.
      const w = window as unknown as { clarity?: { (...args: unknown[]): void; q?: unknown[] } };
      w.clarity =
        w.clarity ||
        function (...args: unknown[]) {
          (w.clarity.q = w.clarity.q || []).push(args);
        };

      this.scriptLoader.loadJsScript(CLARITY_TAG_URL);

      console.log('Clarity enabled');
    });
  }

  static isAppleWebKitMobile(): boolean {
    // This is true for most mobile browsers including Chrome, Safari and Edge.
    // Use to determine that we are on a mobile browser.
    const isMobile = /Mobile\/\w+/.test(navigator.userAgent);

    // True if mobile browser and vendor is Apple
    return isMobile && navigator.vendor.startsWith('Apple');
  }
}
